module.exports = __webpack_public_path__ + "static/media/lora3.85ec6657.jpg";